import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { BonusSettlement } from '../../models/bonus-settlement';

export class BonusSettlementsOverviewApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementsOverview(
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<BonusSettlement>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/supplier-bonus-settlements`, { params: searchParams }),
            response => response.data
        );
    }
}
